<template>
  <section class="section">
    <div class="container">
      <section class="">
        <div class="has-text-primary">
          <a href="https://nano.org/en" class="is-size-1" target="_blank">
            What is NANO?
          </a>
        </div>
        <div class="is-size-2">
          NANO is digital currency for the real world – the fast and free way to pay for everything in life. Why pay for transaction fees when you don't have to?
        </div>
        <div style="height: 2rem"></div>
        <iframe src="https://player.vimeo.com/video/253563861" width="80%" height="360" frameborder="0" allowfullscreen></iframe>
      </section>

      <section class="">
        <div style="height: 2rem"></div>
        <a href="https://nano.org/en" class="is-size-1" target="_blank">
          Learn more at NANO.org
        </a>
      </section>

      <section class="">
        <div class="is-size-3">
          You can find a host of other useful NANO-related products and services by checking out <a href="https://nanolinks.info/" target="_blank">NANOLinks.info</a>
        </div>
      </section>

      <section class="">
        <i-o-t-a-vs-n-a-n-o-content></i-o-t-a-vs-n-a-n-o-content>
      </section>

    </div>
  </section>
</template>

<script>
  import IOTAVsNANOContent from "../components/IOTAVsNANOContent";
  export default {
    name: "About",
    components: {IOTAVsNANOContent}
  }
</script>

<style scoped>

</style>
